import React from "react";
import API from "@unisearch/helpers/api";

import { LayoutMain } from "@unisearch/theme/layout";
import { ExploreBanner } from "@modules/study/explore";
import { UniList } from "@modules/study/university/uni_list";

const Universities = ({ pageData }) => {
  return (
    <LayoutMain
      title="Universities"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/universities`}
    >
      <ExploreBanner title="Explore University" />
      <UniList pageData={pageData} />
    </LayoutMain>
  );
};

export default Universities;

export async function getServerSideProps() {
  let props = {
    pageData: "",
  };

  try {
    let universityResult = await API.get(`university/all`);

    if (universityResult.isSuccess && universityResult.data) {
      props.pageData = universityResult.data;
    }

    return {
      props,
    };
  } catch (err) {
    return {
      props,
    };
  }
}
